<template>
	<div class="tab-body">
		<el-row>
			<el-col :span="12">
				<el-card class="box-card userInfo userInfo_w">
					<div slot="header" class="userInfo-header clearfix"><span>个人信息</span></div>
					<!-- 头像区域 -->
					<el-row class="userInfo-head ">
						<el-col :span="12" class="userHead">
							<!-- <img id="headImg" :src="user.head" v-if="user.head" /> -->
							<!-- <img id="headImg" src="~assets/img/male.jpg" /> -->

							<img style="width: 260px;height: 200px;" v-if="formParameter.head"
								:src="formParameter.head"></img>
							<img style="width: 260px;height: 200px;" v-else
								src="~/assets/img/npro.png"></img>

							<div style=" font-weight: bold;">
								{{ formParameter.name }}
							</div>
						</el-col>
					</el-row>
					<!-- 用户信息区域 -->
					<el-row class="userInfo-boby">
						<el-col :span="6" :offset="6" class="userInfo-text">
							<div>
								<label>性别:</label>
								<span id="sex" name="sex">
									<span v-if="formParameter.dictionary_sex == 1">男</span>
									<span v-if="formParameter.dictionary_sex == 2">女</span>
								</span>
							</div>
							<div>
								<label>专业:</label>
								<span id="subject" name="subject">{{ formParameter.subject }}</span>
							</div>
							<div>
								<label>住址:</label>
								<span id="addr" name="addr">{{ formParameter.addr }}</span>
							</div>

							<div>
								<label>手机:</label>
								<span id="mobile" name="mobile">{{ formParameter.mobile }}</span>
							</div>
							<div>
								<label></label>
								<span id="email" name="email">{{ formParameter.email }}</span>
							</div>
						</el-col>
						<el-col :span="6" class="userInfo-text1">
							<div>
								<label>课程:</label>
								<span id="cid" name="cid">{{ myClz.dbColumn_cid }}</span>
							</div>
							<div>
								<label>部门:</label>
								<span id="dname" name="dname">{{ formParameter.dname }}</span>
							</div>
							<div>
								<label>班级:</label>
								<span id="cid" name="cid">{{ formParameter.dbColumn_cid }}</span>
							</div>
							<div>
								<label>职务:</label>
								<span id="groupleader" name="groupleader">
									<span v-if="formParameter.groupleader == 1">组长</span>
									<span v-if="formParameter.groupleader == 2">组员</span>
								</span>
							</div>
							<div>
								<label>状态:</label>
								<span id="state" name="state">
									<span v-if="formParameter.state == 1">在读</span>
									<span v-if="formParameter.state == 2">休学</span>
									<span v-if="formParameter.state == 3">毕业</span>
								</span>
							</div>
						</el-col>
					</el-row>
					<!-- 按钮区域 -->
					<el-row :gutter="20">
						<el-col :span="12" :offset="6">
							<div class="grid-content bg-purple operation">
								<el-button type="primary" @click="updateInfo">编辑资料</el-button>
								<el-button type="primary" @click="updatePwd">修改密码</el-button>
							</div>
						</el-col>
					</el-row>

				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card class="box-card userInfo userInfo_w">
					<div slot="header" class="userInfo-header clearfix"><span>扫码/关注</span></div>

					<div class="er-box-wrap">
						<div class="box-card-wrap">
						<img style="width: 220px;height: 200px;" 
								src="~/assets/img/xcx.png"></img>

							<div style="color: #409eff">
								学徒制移动端、密码与PC端一致
							</div>
					 </div>
					 <div class="box-card-wrap">
						<img style="width: 200px;height: 200px;" 
								src="~/assets/img/xsbm.jpg"></img>
							<div style="color: #409eff">
								新升报名:线上课、学历、职业考证
							</div>
					 </div>
					 <div class="box-card-wrap">
						 
						<img style="width: 200px;height: 270px;" 
								src="~/assets/img/gzh.png"></img>

							
					 </div>
					 <div class="box-card-wrap">
						<a href="https://author.baidu.com/home/1804354743104031" target="_blank">
						<img style="width: 200px;height: 270px;" 
								src="~/assets/img/bjh.png"></img> </a>
 
					 </div>
					</div>
				    
				</el-card>
			</el-col>

		</el-row>
		<update-info-dialog ref="updateInfoDialog"></update-info-dialog>
		<update-pwd-dialog ref="updatePwdDialog"></update-pwd-dialog>

	</div>
</template>
<script>

import api from '@/api/main.js';
import apiMclz from "@/api/study/myclass2/myclass2.js";
import updateInfoDialog from './updateInfo.vue';
import updatePwdDialog from './updatePwd.vue';


export default {
	name: 'mainPage',
	components: {
		updateInfoDialog,
		updatePwdDialog
	},

	data() {
		return {
			listLoading: false,
			updateInfoDisplay: false,
			updatePwdDisplay: false,
			updatePwdParameter: {},
			listData: [],
			page: new this.$constant.pageObj(),
			formParameter: {},
			barData: [],
			myClz: {}
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.getInfo(params, response => {
				this.formParameter = response.data;
				this.listLoading = false;
			})


		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},
		//编辑用户信息
		updateInfo() {
			this.$refs.updateInfoDialog.open({}, '编辑');
		},
		//编辑密码
		updatePwd() {
			this.$refs.updatePwdDialog.open({}, '编辑');
		},

		makePiePicture(dom) {
			// 基于准备好的dom，初始化echarts实例
			var myChart = this.$echarts.init(document.getElementById(dom));
			// 指定图表的配置项和数据
			var option = {
				xAxis: {
					type: 'category',
					data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
				},
				yAxis: {
					type: 'value'
				},
				grid: {
					left: '3%',
					top: '8%',
					right: '3%',
					bottom: '8%',
					containLabel: true
				},
				series: [{
					data: this.barData,
					type: 'bar',
				}],
				tooltip: {}
			};

			myChart.setOption(option);
		},
		change(val) {
			/* this.confirmLoading = true;
			//编辑
			api.updateInfo(
				this.formParameter,
				response => {
					this.$utils.msg.success(response.msg);
					this.confirmLoading = false;
				},
				response => {
					this.$utils.msg.warning(response.msg);
					this.confirmLoading = false;
				}
			); */
		}
	},
	mounted() {
		this.list();
		apiMclz.getClassOne({}, res => {
			this.myClz = res.data
			this.$caches.myCourse.set(this.myClz.dbColumn_cid);
		})
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/main.scss';

.el-col-6 {
	width: 80%;
}
.box-card-wrap{
	width: 50%;
	height: 50%;
	display: flex;
	padding: 20px;
	box-sizing: border-box;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.er-box-wrap{
     display: flex;
	 flex-wrap: wrap;
	
}
</style>
